// extracted by mini-css-extract-plugin
module.exports = {"block":"AdFreeCta_block__rzwbT","toggle":"AdFreeCta_toggle__oHxHp","knob":"AdFreeCta_knob__jsqtY"};